import { cn } from '@/lib/utils';

import { FileUpload, FileUploadProps } from '@/components/atoms/FileUpload';
import { Text } from '@/components/atoms/Text';

export interface FileUploadFormControlProps extends FileUploadProps {
  inputLabels: {
    label: React.ReactNode | string;
    disclaimer?: React.ReactNode | string;
  };
  error?: string;
  acceptedFileTypes: string[];
}

export const FileUploadField = ({
  name,
  value,
  label,
  inputLabels,
  error,
  acceptedFileTypes,
  onBlur,
  onChange,
  onFileRemove,
  classNames,
}: FileUploadFormControlProps) => (
  <div>
    <Text
      as='div'
      variant='body-m'
      classNames={{
        wrapper: cn('pb-2', !!error ? 'text-error-500' : 'text-gray-950'),
      }}
    >
      {typeof label === 'string' ? <p>{label}</p> : label}
    </Text>

    <FileUpload
      classNames={{
        ...classNames,
        root: cn('pb-5 md:pb-4', classNames?.root),
      }}
      {...inputLabels}
      name={name}
      value={value}
      accept={acceptedFileTypes.join(',')}
      onChange={onChange}
      onBlur={onBlur}
      onFileRemove={onFileRemove}
    />
    {error && (
      <Text
        variant='body-s-bold'
        className='text-error-500 dark:text-error-500'
      >
        {error}
      </Text>
    )}
  </div>
);
